const paymentMethodsUrl = "v1/credit/billing/payments/methods";
const creditAccountsUrl = "v2/credit/accounts";
export {
  creditAccountsUrl,
  paymentMethodsUrl
};
//# sourceMappingURL=endpoints.js.map
